import { render, staticRenderFns } from "./assetInventoryManageList.vue?vue&type=template&id=4637ff20&scoped=true"
import script from "./assetInventoryManageList.vue?vue&type=script&lang=js"
export * from "./assetInventoryManageList.vue?vue&type=script&lang=js"
import style0 from "./assetInventoryManageList.vue?vue&type=style&index=0&id=4637ff20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4637ff20",
  null
  
)

export default component.exports